import { useEffect, useState } from "react";


type VideoSideBarProps = {
    courseTitle: string;
    lessonTitle: string;
    subLessonTitle: string;
    selectedContent: number | null;
    setSelectedContent: (value: number | null) => void;
    selectedVideo: number | null;
    setSelectedVideo: (value: number | null) => void;
    subLessonOrderData: any[];
    onCourseClick: () => void;
    onLessonClick: () => void;
};

export const VideoSideBar = ({
    courseTitle,
    lessonTitle,
    subLessonTitle,
    selectedContent,
    setSelectedContent,
    selectedVideo,
    setSelectedVideo,
    subLessonOrderData,
    onCourseClick,
    onLessonClick,
}: VideoSideBarProps) => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);

    useEffect(() => {
        if (isSidebarOpen) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => document.body.classList.remove("overflow-hidden");
    }, [isSidebarOpen]);

    return (
        <>
            <div className="md:h-[calc(100vh-200px)] thin-scrollbar overflow-y-auto w-64 overflow-auto border-r border-[#D0D0D0] p-3 bg-white max-md:w-full">
                <div className="mb-4 max-md:hidden">
                    <div
                        className="text-primary font-semibold text-base cursor-pointer hover:underline flex items-center gap-1"
                        onClick={onCourseClick}
                    >
                        {courseTitle} <span className="text-black">&gt;</span>
                    </div>
                    <div
                        className="text-primary font-semibold text-base cursor-pointer hover:underline mt-1"
                        onClick={onLessonClick}
                    >
                        {lessonTitle}
                    </div>
                </div>

                {subLessonTitle && (
                    <div className="text-gray-600 font-medium py-2 border-b border-gray-200 mb-2 max-md:hidden">{subLessonTitle}</div>
                )}

                <div className="space-y-2 max-md:hidden">
                    {subLessonOrderData?.map((item: any, index: number) => {
                        const isActive = selectedContent && selectedContent > 0 ? selectedContent === item?.contentId : selectedVideo && selectedVideo > 0 ? selectedVideo === item?.videoId : false;
                        return (
                            <div
                                key={index}
                                className={`flex items-center gap-2 cursor-pointer
                            ${isActive ? "text-primary font-semibold" : "text-gray-700 hover:text-primary hover:font-semibold"}
                            border-b border-gray-200
                           
                        `}
                                onClick={() => {
                                    if (item?.contentId > 0) {
                                        setSelectedContent(item?.contentId)
                                        setSelectedVideo(null)
                                    }
                                    else if (item?.videoId) {
                                        setSelectedVideo(item?.videoId)
                                        setSelectedContent(null)
                                    }

                                }}
                            >
                                <span className="material-symbols-outlined text-2xl">
                                    {item?.contentId > 0 ? "docs" : item?.videoId > 0 ? "videocam" : ""}
                                </span>
                                <span className="text-sm">{item?.contentId > 0 ? item?.contentTitle : item?.videoId > 0 ? item?.videoTitle : ""}</span>
                            </div>
                        );
                    })}
                </div>
                <div className="w-full p-3 border-b border-[#D0D0D0] md:hidden flex justify-end items-center">

                    {/* Mobile Menu Button */}
                    <button onClick={() => setSidebarOpen(true)}>
                        <span className="material-symbols-outlined text-3xl">menu</span>
                    </button>
                </div>
            </div>

            {isSidebarOpen && (
                <div className="fixed inset-0 z-[10000] flex">

                    {/* BACKDROP */}
                    <div
                        className="fixed inset-0 bg-black bg-opacity-40"
                        onClick={() => setSidebarOpen(false)}
                    />

                    {/* SLIDING DRAWER */}
                    <div className="relative z-[10001] w-72 bg-white h-screen shadow-xl animate-slideIn pb-12">

                        {/* Header */}
                        <div className="flex items-center justify-end p-4 border-b">

                            <button onClick={() => setSidebarOpen(false)}>
                                <span className="material-symbols-outlined text-3xl">close</span>
                            </button>
                        </div>

                        {/* Lesson Items */}
                        <div className="overflow-y-auto max-md:h-[calc(100vh-200px)] p-2">
                            <div className="mb-4">
                                <div
                                    className="text-primary font-semibold text-base cursor-pointer hover:underline flex items-center gap-1"
                                    onClick={() => {
                                        setSidebarOpen(false);
                                        onCourseClick()
                                    }}
                                >
                                    {courseTitle} <span className="text-black">&gt;</span>
                                </div>
                                <div
                                    className="text-primary font-semibold text-base cursor-pointer hover:underline mt-1"
                                    onClick={() => {
                                        setSidebarOpen(false);
                                        onLessonClick()
                                    }}
                                >
                                    {lessonTitle}
                                </div>
                            </div>

                            {subLessonTitle && (
                                <div className="text-gray-600 font-medium py-2 border-b border-gray-200 mb-2">{subLessonTitle}</div>
                            )}

                            <div className="space-y-2">
                                {subLessonOrderData?.map((item: any, index: number) => {
                                    const isActive = selectedContent && selectedContent > 0 ? selectedContent === item?.contentId : selectedVideo && selectedVideo > 0 ? selectedVideo === item?.videoId : false;
                                    return (
                                        <div
                                            key={index}
                                            className={`flex items-center gap-2 cursor-pointer
                            ${isActive ? "text-primary font-semibold" : "text-gray-700 hover:text-primary hover:font-semibold"}
                            border-b border-gray-200
                           
                        `}
                                            onClick={() => {
                                                setSidebarOpen(false);
                                                if (item?.contentId > 0) {
                                                    setSelectedContent(item?.contentId)
                                                    setSelectedVideo(null)
                                                }
                                                else if (item?.videoId) {
                                                    setSelectedVideo(item?.videoId)
                                                    setSelectedContent(null)
                                                }

                                            }}
                                        >
                                            <span className="material-symbols-outlined text-2xl">
                                                {item?.contentId > 0 ? "docs" : item?.videoId > 0 ? "videocam" : ""}
                                            </span>
                                            <span className="text-sm">{item?.contentId > 0 ? item?.contentTitle : item?.videoId > 0 ? item?.videoTitle : ""}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};